import React from 'react';
import {IntegrationApiOptionsFieldV2} from "../IntegrationApiOptionsFieldV2";

interface Props {
    readonly onChange: (name: string, value: any) => void,
    readonly data: any
}

export function IntegrationApiHeaders({onChange,data}: Props) {
    return (
        <div>
            <IntegrationApiOptionsFieldV2 data={data.headers} onChange={(value) => onChange("headers", value)}/>
        </div>
    );
}




